// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"90a32dfb","385":"dbacdeb8"}[chunkId] + ".chunk.js";
};